import { getCookies } from '@/utils/cookies'
import Api from './API'
const crypto = require('crypto')
function CrmModal () {
  if (!(this instanceof CrmModal)) {
    return new CrmModal()
  }
}
// ++++++++++++++++++++++++++++ user login and user data api call start ++++++++++++++++++++++++++++
var keyStr = 'CrmGB!m3@p!'
// init app api

CrmModal.prototype.loginUser = async function (
  email,
  password,
  callBackFunc,
  onError
) {
  const algorithm = 'aes-256-cfb'
  const hash = crypto.createHash('sha256')
  hash.update(keyStr)
  const keyBytes = hash.digest()
  const iv = crypto.randomBytes(16)
  console.log('password', password)
  const cipher = crypto.createCipheriv(algorithm, keyBytes, iv)
  const enc = [iv, cipher.update(password, 'utf8')]
  enc.push(cipher.final())
  password = Buffer.concat(enc).toString('base64')
  const data = {
    email: email,
    password: password
  }
  console.log(data)
  Api.login(data).then(data => {
    if (data.success === 1) {
      callBackFunc(data)
    } else {
      onError(data)
    }
  })
}

// CrmModal.prototype.autoLoginUser = async function (
//   email,
//   password,
//   crmId,
//   rememberMe,
//   callBackFunc,
//   onError
// ) {
//   const data = {
//     email: email,
//     password: password,
//     platform: 'web',
//     crmId: crmId
//   }
//   Api.login(data).then(data => {
//     if (data.success === 1) {
//       callBackFunc(data)
//     } else {
//       onError(data)
//     }
//   })
// }
// /*
// * get list of permissions
// */
CrmModal.prototype.UserPermissionList = async function (
  authToken,
  callBackFunc,
  onError
) {
  const data = new FormData()
  data.append('authToken', authToken)
  Api.UserPermissionList(data).then(data => {
    if (data.success === 1) {
      callBackFunc(data)
    } else {
      onError(data)
    }
  })
}
// /*******----------------company detail API ------------------------***********/
CrmModal.prototype.companyBasicInfo = async function (
  companyId,
  callBackFunc,
  onError
) {
  const data = new FormData()
  data.append('authToken', getCookies('authToken'))
  data.append('companyId', companyId)
  Api.companyBasicInfo(data).then(data => {
    if (data.success === 1) {
      callBackFunc(data)
    } else {
      onError(data)
    }
  })
}

CrmModal.prototype.companyList = async function (
  params,
  callBackFunc,
  onError
) {
  console.log(params)
  const data = new FormData()
  data.append('authToken', getCookies('authToken'))
  data.append('start', params.start)
  data.append('length', params.length)
  data.append('sortColumnName', params.sortColumnName)
  data.append('sortColumnOrder', params.sortColumnOrder)
  data.append('searchValue', params.searchValue)
  Api.companyList(data).then(data => {
    if (data.success === 1) {
      callBackFunc(data)
    } else {
      onError(data)
    }
  })
}

CrmModal.prototype.companystaffList = async function (
  params,
  callBackFunc,
  onError
) {
  const data = new FormData()
  data.append('authToken', getCookies('authToken'))
  data.append('start', params.start)
  data.append('length', params.length)
  data.append('searchValue', params.searchValue)
  data.append('companyId', params.companyId)
  Api.companystaffList(data).then(data => {
    if (data.success === 1) {
      callBackFunc(data)
    } else {
      onError(data)
    }
  })
}

CrmModal.prototype.companyAppSetting = async function (
  companyId,
  callBackFunc,
  onError
) {
  const data = new FormData()
  data.append('authToken', getCookies('authToken'))
  data.append('companyId', companyId)
  Api.companyAppSetting(data).then(data => {
    if (data.success === 1) {
      callBackFunc(data)
    } else {
      onError(data)
    }
  })
}

CrmModal.prototype.companyEmailConfigurationList = async function (
  companyId,
  callBackFunc,
  onError
) {
  const data = new FormData()
  data.append('authToken', getCookies('authToken'))
  data.append('companyId', companyId)
  Api.companyEmailConfigurationList(data).then(data => {
    if (data.success === 1) {
      callBackFunc(data)
    } else {
      onError(data)
    }
  })
}

CrmModal.prototype.companyDeviceList = async function (
  params,
  callBackFunc,
  onError
) {
  const data = new FormData()
  data.append('authToken', getCookies('authToken'))
  data.append('companyId', params.companyId)
  data.append('start', params.start)
  data.append('length', params.length)
  data.append('searchValue', params.searchValue)
  Api.companyDeviceList(data).then(data => {
    if (data.success === 1) {
      callBackFunc(data)
    } else {
      onError(data)
    }
  })
}

CrmModal.prototype.CompanyStorageInfo = async function (
  companyId,
  callBackFunc,
  onError
) {
  const data = new FormData()
  data.append('authToken', getCookies('authToken'))
  data.append('companyId', companyId)
  Api.CompanyStorageInfo(data).then(data => {
    if (data.success === 1) {
      callBackFunc(data)
    } else {
      onError(data)
    }
  })
}

CrmModal.prototype.companyThirdPartyIntegration = async function (
  companyId,
  callBackFunc,
  onError
) {
  const data = new FormData()
  data.append('authToken', getCookies('authToken'))
  data.append('companyId', companyId)
  Api.companyThirdPartyIntegration(data).then(data => {
    if (data.success === 1) {
      callBackFunc(data)
    } else {
      onError(data)
    }
  })
}

CrmModal.prototype.dashboardBasicInfo = async function (
  callBackFunc,
  onError
) {
  const data = new FormData()
  data.append('authToken', getCookies('authToken'))
  Api.dashboardBasicInfo(data).then(data => {
    if (data.success === 1) {
      callBackFunc(data)
    } else {
      onError(data)
    }
  })
}

CrmModal.prototype.emailConfigurationDetail = async function (
  params,
  callBackFunc,
  onError
) {
  const data = new FormData()
  data.append('authToken', getCookies('authToken'))
  data.append('emailConfigId', params.emailConfigId)
  Api.emailConfigurationDetail(data).then(data => {
    if (data.success === 1) {
      callBackFunc(data)
    } else {
      onError(data)
    }
  })
}
CrmModal.prototype.ResumeEmailReading = async function (
  emailConfigId,
  callBackFunc,
  onError
) {
  const data = new FormData()
  data.append('authToken', getCookies('authToken'))
  data.append('emailConfigId', emailConfigId)
  Api.ResumeEmailReading(data).then(data => {
    if (data.success === 1) {
      callBackFunc(data)
    } else {
      onError(data)
    }
  })
}

CrmModal.prototype.appSettingDetail = async function (
  callBackFunc,
  onError
) {
  const data = new FormData()
  data.append('authToken', getCookies('authToken'))
  Api.appSettingDetail(data).then(data => {
    if (data.success === 1) {
      callBackFunc(data)
    } else {
      onError(data)
    }
  })
}

CrmModal.prototype.saveAppSettingDetail = async function (
  AppSettingData,
  callBackFunc,
  onError
) {
  const data = new FormData()
  data.append('authToken', getCookies('authToken'))
  data.append('AppSettingData', JSON.stringify(AppSettingData))
  Api.saveAppSettingDetail(data).then(data => {
    if (data.success === 1) {
      callBackFunc(data)
    } else {
      onError(data)
    }
  })
}

CrmModal.prototype.addUserDetails = async function (
  UserData,
  file,
  callBackFunc,
  onError
) {
  const data = new FormData()
  data.append('authToken', getCookies('authToken'))
  data.append('UserData', JSON.stringify(UserData))
  data.append('file', file)
  Api.addUserDetails(data).then(data => {
    if (data.success === 1) {
      callBackFunc(data)
    } else {
      onError(data)
    }
  })
}

CrmModal.prototype.userListing = async function (
  params,
  callBackFunc,
  onError
) {
  console.log(params)
  const data = new FormData()
  data.append('authToken', getCookies('authToken'))
  data.append('start', params.start)
  data.append('length', params.length)
  data.append('searchValue', params.searchValue)
  data.append('sortColumnName', params.sortColumnName)
  data.append('sortColumnOrder', params.sortColumnOrder)
  Api.userListing(data).then(data => {
    if (data.success === 1) {
      callBackFunc(data)
    } else {
      onError(data)
    }
  })
}

CrmModal.prototype.userDetail = async function (
  superAdminUserId,
  callBackFunc,
  onError
) {
  const data = new FormData()
  data.append('authToken', getCookies('authToken'))
  data.append('superAdminUserId', superAdminUserId)
  Api.userDetail(data).then(data => {
    if (data.success === 1) {
      callBackFunc(data)
    } else {
      onError(data)
    }
  })
}

CrmModal.prototype.userDetailUpdate = async function (
  group,
  userData,
  superAdminUserId,
  file,
  callBackFunc,
  onError
) {
  const data = new FormData()
  data.append('authToken', getCookies('authToken'))
  data.append('group', group)
  data.append('superAdminUserId', superAdminUserId)
  data.append('userData', JSON.stringify(userData))
  data.append('file', file)
  Api.userDetailUpdate(data).then(data => {
    if (data.success === 1) {
      callBackFunc(data)
    } else {
      onError(data)
    }
  })
}

CrmModal.prototype.userEmailValidate = async function (
  email,
  superAdminUserId,
  callBackFunc,
  onError
) {
  const data = new FormData()
  data.append('authToken', getCookies('authToken'))
  data.append('email', email)
  data.append('superAdminUserId', superAdminUserId)
  Api.userEmailValidate(data).then(data => {
    if (data.success === 1) {
      callBackFunc(data)
    } else {
      onError(data)
    }
  })
}
export default CrmModal



// WEBPACK FOOTER //
// ./src/api/CrmModel.js